const B = "https://static.prod-images.emergentagent.com/jobs/3d10772a-cb67-43bb-b3d0-4bc6c89f8f66/images/";

export const SYMBOL_IMG = {
  cherry: "a21cec94cb593bd3c0cef1fdf1c87c4feff3e06235c37365411f9cc6dc57ab60",
  lemon: "d1a0df4f28fee1e4f0e7895b0028e555e46c1376d3f0f7e87fb11191b808ca72",
  grape: "85660f73470ba3c7d4faa186d84c68839c6380c31db74e7b050bd2e05868ed21",
  bell: "e58559bec88fe8e63bcf06eee5359383d49b233287a3399920d7f90d7ec30936",
  star: "1adf92aa252f7171393b4e2fe44fa066b198c935aaebd9dc22fc4ec4758e5777",
  seven: "fd52c79cd5a9aa92580772a4b10799cf557b62006e8bc677aa29e47c23c49850",
  emerald: "af804fcbb70e856e3a2e988c5b888d538c36ce983d0e94dc065c74eb012d6171",
  sapphire: "81407ac3f5f56e9b0d7a324cc03986a48864e70ae7a9585ccdfb3cbb0193cea0",
  ruby: "83609cf3114598a7ca6e71b6e4caac3eb7ce79c757dddfea27d4792c5d7fd9ec",
  coins: "fda80e0b289fb873cdfe2d7aa57bb702fbe9993a7b05dba1ae9d1b8c2a9e065e",
  diamond: "ad8d7fc36ffb93ec9d58f085510c419bd27e118a3832d42ae046c66ffee10d31",
  crown: "b74ecf286ff15998576d18c53c912ed12e86d2013fc95f186fe84b90bdfb68ee",
  fish: "faee97067a4a9ed915fcfa93052cbc29a106b84fb069cb8b6bf111a2db8671e0",
  shell: "39ea7b062c9f5cf031e2ffa5a2cd689235a5eba65d3eb5dcd5cd3c81a9b0eaad",
  anchor: "1c7221f769f1fd91907ae964d68c03540663fdfe71b580a62f92e804f47de9f4",
  ship: "66e0435fda07a143f70b587edf4cfc008dfc61684234f191f5982ea91e3fead3",
  pearl: "e8637d97d326e2f50289969ede52ef489ac1c137bc9ae64d26542fc02446678b",
  trident: "a8b6c8902663f8d753fbbd16328ff8378f1ddabfd5f0aa8345367b3736929ebb",
  moon: "0685ac002281f6c2a1528861f3384669a73e775974ef039c27991afc61151ec4",
  sun: "72636bcd0db7832fa724c3c70ba5865ff1de65c01b50b56a643bc944696e3e2f",
  orbit: "e09120687e2a7049c27be640a7fcc4e0cc56dbc9ab1fb5b36bccb93b98746c28",
  satellite: "a686474769c7c55a84fed3465bc55fe55cd50f0419ee63159d4a8f63001b40b1",
  comet: "5714efd82cb5a7f66f7c8708d63a831b1f017a43b90b3bce5459ceecc1a57df9",
  rocket: "d279e4fc6277c8a8380712759954635c14edc395ba808d8572785a9e8315e1bb",
  egg: "b211520cff69fe13036329ec271bb947cc4dbeec14912c59df65643ec05353d8",
  shield: "35f17bf4cdbfe812dca45916b05aa68822ee0f49845535a17217375630c4da02",
  swords: "a41bfdfa71bf8ec6fc3b4e9ab72e89c55f8354e7ceaa5d98f7cdc0284474d7d6",
  castle: "cc3ee11c43614f59224a7dc290cc851f070ed6f930349e95641acff4a5e01bd7",
  fire: "2d14f79abd47ea40feaa17461c083194ae641c89cc46430cd4da081a9bff0a0f",
  dragon: "b03e86a7e6e54e77060fcd35ff4bb62bee39d8f273b855090638ddfc5ee60295",
  melon: "4d101165511cd0e23795586efca09ccbdbd2306d4b3c7235072ea32820682df1",
  plum: "cd9e52f9f7d42bb07f514aab532a2a6d3137d21c9d06752339e63e8775c11a9b",
  heart: "3ed70e3b6798bf107811670da0f831144f4fa3a672546bf6350cd74d7ffef4cf",
  bar: "fcc9d22289687109d15e18ac2b9af11968d920571d140cbd808dd312998930ea",
  bseven: "6bb4215dac7234c41f5f66dd050d9bbc0a7ea5d67930d3b5b0c732b67ec6c260",
  bstar: "1adf92aa252f7171393b4e2fe44fa066b198c935aaebd9dc22fc4ec4758e5777",
  ankh: "4aa726e7097c1786141de34a44e74138bfbad9c6466413842f1d8d216d73cff0",
  scarab: "c4d092f1933591ca7d5a092574580f41e316e71d48ec57e979099780e1565e1d",
  eye: "a343f5a3ff9c75f74651e749a22ac2d5ce4f9e8d2ec17aa127dfc292e206c0a6",
  bastet: "88bee581532abd241e3bf67f83e3c999b8c7de88ec50975c04b291cdcba2a917",
  pyramid: "408914e017508798ffde88fca31cd94612a38f7aeb5b1c72eca262e54d78ec60",
  pharaoh: "828394a5689cdd511a066d8f53cfab71c05f178898c5c011528b06c7149aa094",
  horseshoe: "9f4bb247791f5bf8963139c1635997ae50230e895e289a6064848a92c572254b",
  boot: "ac478db0f0f1e666c1262e3210d73a718dfec42a1d44e471abfbb94618f89645",
  sheriff: "536cc826628d5417ea77ff0b41269e889443c4d0dbec35b537d2264c6a78eccf",
  revolver: "933028a987eb755059aa0dfd416ff7d1abeb63f85f65d6f5499e6c780bfd9604",
  badge: "9522f35061bb135ab139ef32cea1cd71ae0d7ce040673ef75d83c3445713b7b8",
  goldbag: "d75e97984cbba0bd5d5b19ee7300c7abad2e4f7aa97b4aa5681503532b44dee4",
  rune: "574d2895132a627171a663aa5da08137cee3670bdd4e276c4712287280eaeabf",
  mead: "e2c783dab7056574de645dbe440c9a9680e2c9b08cfc154ffcf9e16342cda6f7",
  vaxe: "56196e4b7f23f80802552ecd2b042af4c07388c7a2daaf0cdaaf338674eba63d",
  vhelmet: "78d18870b68afe80761a3c12e85f2229d0998da45205fa22872e577bafbe27cf",
  longship: "cd04ada32940ef7cf897b1f801c7a87e9760ec372bc59936955550bf4fd07570",
  thor: "257164765e17254317586397d58f213ffb7ffc5df6cfd4a01762f538c7ac6a83",
  gummy: "b4f948d3a187787109549bfbdd9964cfbc6ab8eba73cfef88c445d7894dd0a31",
  lolly: "39c8e16364890161d1bdf656fe40dc8151fa1142cffc36ec05feb1d5ad9ef9b8",
  donut: "52155e935d5e13a9cb5e8bed7af6f10ec139e6700da26e73f79e622ca4148b55",
  cupcake: "9418fa1bcf42549971bd4cfcf63b08de3b533c91c752cec2964a14c5d6a39b7c",
  candyheart: "7e6aadce24554c354dc38a3b22ad695190f38622792c1bb41d711e965bb6609b",
  rainbow: "017c0c7525589a08c73282540186ec77d7a7a748bc8e773fe6623e49ec254292",
  jade: "2015ef5bbee7983ea1c9ccfa14758e328a3a6324c5b067b1204abb9498f341ae",
  totem: "0ec7283e89f9f59ce944621da5cd703334e427118b7c0c5046de9f4dcfd7965b",
  aztmask: "5d7c8c8f908d5940d5b1bd957542fb6cadde7191749097d0172e17131195ee0e",
  jaguar: "931a0ea7f2e2f0ac42318c90f01aa46e1d0cd566da0b11b3c0d0abc8f5a344ef",
  sunstone: "320ea1af29b084c661a3b80b7a879f34b0c196ec820265f800717d2b4c722987",
  quetzal: "3786f184cb28aaeed4e06633c104a82e4111560a0036d9ee4ef4c98c06c6af40",
  bamboo: "6322193dfbbe89b47567fdc6209882f7e5ac13615c7e86fbdbf226d84eee6c16",
  lantern: "de57a0d32b522f0ea99f461d955d2e49bc4431e1a9e423155fd2464c74a7c612",
  jcoin: "e9240c4c12dd4a1df74ef3a11317d257c07b97ac34fec9f2019267d93c093a38",
  koi: "c032404847005a5e791a20a3f2d43986b9ecdbfd7440d170f9e9ace397360733",
  ingot: "41c5b52edf7bfc7b549d2db2b1623abe944af205284953d74e0045e66add86c3",
  panda: "4c015b1ef97d20c777c774bac897b826f1056555acf50dbdf1494669c438e60e",
  nlemon: "09f77cfcd8d98275fe96d718eb88d76ebfc9514f7a7920a53271eb9eaaa64778",
  ncherry: "f1e54b0301bc995e9e6c4c97bf6b14d5c44a475d2442c2ddb4b1e2cd2110e534",
  nbar: "2d4f7de0d136b209e9406c69f7b6aa4ba604f82cdb9a268bfaf83d3e4a0214c2",
  ndice: "cc5655eca7064cabf601ac0288777ffc0bda6bca4d49dbe568fecc8c5dd239e6",
  nchip: "24d9cbf4b33df5c21b63ade75912f295dcb9acb2af1a4c064a4a1e8aa03912a9",
  nseven: "2468f87567dc6864eafe9e731cced54c491e8508e5beeddc49cb4a9db556df64",
  scatter: "dceb7ca7923e0a8625479c1a35d4afa14d6ce9e0723e6052a238bce3c1320301",
};

export const symbolUrl = (name) => (SYMBOL_IMG[name] ? `${B}${SYMBOL_IMG[name]}.jpeg` : null);
